export const settings = [
  {
    label: "Header background",
    type: "background-color",
    selector: "content",
    value: "#333"
  },
  {
    label: "Content background",
    type: "background-color",
    selector: "form",
    value: "#f7f7f7"
  },
  {
    label: "Border radius",
    type: "border-radius",
    selector: "form",
    value: 0
  },
  {
    label: "Height",
    type: "height",
    selector: "content",
    value: 480
  },
  {
    label: "Background image",
    type: "background-image",
    selector: "background",
    value: "url(//pages.convertkit.com/assets/monterey/bg.jpg)"
  },
  {
    label: "Image opacity",
    type: "opacity",
    selector: "background",
    value: "0.3"
  },
  {
    group: "header",
    type: "color",
    selector: "header",
    value: "#ffffff"
  },
  {
    group: "header",
    type: "font-size",
    selector: "header",
    value: 36
  },
  {
    group: "header",
    type: "font-weight",
    selector: "header",
    value: 700
  },
  {
    group: "subheader",
    type: "color",
    selector: "subheader",
    value: "#ffffff"
  },
  {
    group: "subheader",
    type: "font-size",
    selector: "subheader",
    value: 22
  },

  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#4D4D4D"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#e3e3e3"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 0
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#ffffff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#333333"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 0
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 400
  }
]
